import { IconButton, Menu, MenuButton, MenuItem, MenuItemProps, MenuList, Tooltip } from '@chakra-ui/react';
import { HiEllipsisVertical } from 'react-icons/hi2';

type Action = MenuItemProps & {
  label: string;
  isDisabled?: boolean;
  tooltip?: string;
};
type ActionMenuProps = {
  actions: Action[];
  isLoading?: boolean;
};

export const ActionMenu = ({ actions, isLoading = false }: ActionMenuProps) => {
  const renderAction = (action: Action) => {
    return (
      <Tooltip key={action.label} label={action?.tooltip || ''} aria-label={action?.tooltip || ''}>
        <MenuItem
          key={action.label}
          icon={action.icon}
          onClick={action.onClick}
          {...action}
          isDisabled={action.isDisabled}
        >
          {action.label}
        </MenuItem>
      </Tooltip>
    );
  };

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<HiEllipsisVertical />}
        variant="ghost"
        colorScheme="gray"
        isLoading={isLoading}
        _hover={{ bgColor: 'whiteAlpha.100' }}
        _active={{ bgColor: 'none' }}
      />
      <MenuList>{actions.map(renderAction)}</MenuList>
    </Menu>
  );
};
